import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditomanmadcab() {



    const cardData = {





keyword: "Shirdi to Manmad Cab",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Manmad Cab service for passengers, families, devotees, business travelers, and groups traveling from Shirdi to Manmad and nearby destinations. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way travel, round trips, railway station transfers, business visits, family journeys, and customized local sightseeing. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup timings, and convenient drop arrangements, travelers can enjoy a smooth journey from Shirdi to Manmad. The service is particularly useful for passengers connecting their Shirdi pilgrimage with Manmad Railway Station and nearby towns, while additional destinations can be included according to the traveler's itinerary.",

topPlaces: [
  {
    title: "Manmad Railway Station",
    description: "Manmad Railway Station is an important railway junction in Maharashtra and a major travel point for passengers connecting to different cities. Travelers leaving Shirdi can book a private cab for a convenient station transfer without relying on multiple local transport options. Sai Shirdi Cab offers flexible pickup timings and vehicles with adequate luggage space for families and groups."
  },
  {
    title: "Yeola",
    description: "Yeola is a historic town in Nashik district known for its traditional Paithani weaving and cultural heritage. Travelers heading toward the Manmad region can include Yeola as an additional stop for shopping, local exploration, or family visits. Private cab transportation allows passengers to customize their journey and travel comfortably between nearby destinations."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and commercial city that can be combined with a Shirdi to Manmad journey. Travelers can explore temples, heritage locations, vineyards, and other attractions around the city. Sai Shirdi Cab provides comfortable private vehicles for customers planning an extended itinerary beyond Manmad."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a renowned pilgrimage destination near Nashik and is home to one of the twelve Jyotirlinga temples dedicated to Lord Shiva. Devotees traveling through the Manmad region can include Trimbakeshwar in a customized religious tour. A private cab makes it convenient to cover the temple and surrounding destinations at a flexible pace."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic hill destination in the Nashik region known for mountains, valleys, waterfalls, and pleasant natural surroundings. Travelers looking to extend their Shirdi-Manmad trip can add Igatpuri for sightseeing or a short getaway. Customers can book a spacious chauffeur-driven vehicle for comfortable travel with family and luggage."
  },
  {
    title: "Sinnar",
    description: "Sinnar is an important town in Nashik district with religious, industrial, and regional significance. It can be included as a convenient stop for travelers exploring the area around Manmad and Nashik. Sai Shirdi Cab provides flexible private transportation for customers who want to combine multiple destinations in one itinerary."
  },
  {
    title: "Chandwad",
    description: "Chandwad is a historic town in Nashik district known for temples, forts, and traditional heritage. Travelers can include Chandwad while exploring destinations around Manmad and the northern Nashik region. Private cab travel offers the flexibility to visit local attractions without depending on fixed public transportation schedules."
  }
],


"services": [
  {
    "name": "Shirdi to Manmad Taxi Fare",
    "description": "Shirdi to Manmad Taxi Fare service helps travelers plan convenient transportation between Shirdi and Manmad. The fare can vary according to the selected vehicle, journey type, passenger requirements, and pickup or drop location."
  },
  {
    "name": "Shirdi to Manmad Taxi",
    "description": "Shirdi to Manmad Taxi provides private and comfortable transportation for passengers traveling between Shirdi and Manmad. Suitable cab options can be arranged for devotees, families, business travelers, and passengers heading toward Manmad Railway Station."
  },
  {
    "name": "Taxi Charges from Manmad to Shirdi",
    "description": "Taxi Charges from Manmad to Shirdi depend on the vehicle category, travel requirements, and type of journey selected. Sedan, Ertiga, SUV, and Innova options can be arranged for passengers traveling from Manmad toward Shirdi."
  },
  {
    "name": "Manmad to Shirdi Taxi Fare",
    "description": "Manmad to Shirdi Taxi Fare provides travelers with a convenient way to arrange private transportation to Shirdi. The overall fare may depend on the selected vehicle, pickup point, number of passengers, and one-way or return travel requirements."
  },
  {
    "name": "Manmad to Shirdi Cab Fare",
    "description": "Manmad to Shirdi Cab Fare varies according to the vehicle type and journey plan. Travelers can select an economical sedan or a spacious Ertiga, SUV, or Innova according to their luggage, family size, and comfort preferences."
  },
  {
    "name": "Manmad to Shirdi Cab Booking",
    "description": "Manmad to Shirdi Cab Booking allows passengers to arrange their private ride in advance for a convenient journey to Shirdi. The service is suitable for devotees, families, senior travelers, and passengers arriving at Manmad Railway Station."
  },
  {
    "name": "Manmad to Shirdi Taxi Price",
    "description": "Manmad to Shirdi Taxi Price depends on the selected vehicle, pickup location, travel schedule, and journey type. Customers can choose suitable cab options for direct transfers, temple visits, family travel, and return journeys."
  },
  {
    "name": "Cab from Manmad to Shirdi",
    "description": "Cab from Manmad to Shirdi provides direct private transportation for travelers heading to Shirdi Sai Baba Temple. Comfortable vehicles can be arranged for individual passengers, couples, families, and groups with convenient pickup from Manmad."
  },
  {
    "name": "Shirdi to Manmad Innova Crysta Cab",
    "description": "Shirdi to Manmad Innova Crysta Cab offers a spacious and comfortable travel option for families, groups, and passengers carrying extra luggage. The premium vehicle can be arranged for railway station transfers, local travel, and intercity journeys."
  },
  {
    "name": "Shirdi to Manmad Innova Cab",
    "description": "Shirdi to Manmad Innova Cab provides spacious transportation for families and groups traveling between Shirdi and Manmad. The vehicle is suitable for devotees, railway station transfers, and passengers looking for additional seating and luggage space."
  },
  {
    "name": "Hire Innova Crysta in Shirdi",
    "description": "Hire Innova Crysta in Shirdi provides a premium vehicle option for travelers requiring comfortable transportation for local and outstation journeys. The Innova Crysta can be arranged for Manmad transfers, pilgrimage trips, family travel, and multi-destination tours."
  },
  {
    "name": "Shirdi to Manmad 17 Seater Tempo Traveller on Rent",
    "description": "Shirdi to Manmad 17 Seater Tempo Traveller on Rent is suitable for large families, pilgrimage groups, and organized travelers. The spacious vehicle provides convenient group transportation between Shirdi and Manmad with suitable luggage capacity."
  },
  {
    "name": "Shirdi to Manmad 7 Seater on Rent",
    "description": "Shirdi to Manmad 7 Seater on Rent provides a practical option for families and small groups traveling together. A spacious seven-seater vehicle can be arranged for comfortable transportation between Shirdi, Manmad, and nearby destinations."
  },
  {
    "name": "Shirdi to Manmad Ertiga on Rent",
    "description": "Shirdi to Manmad Ertiga on Rent offers comfortable multi-passenger transportation for families and small groups. The vehicle provides additional seating and luggage space for railway station transfers, pilgrimage travel, and one-way or return journeys."
  },
  {
    "name": "Shirdi to Manmad Mini Bus on Rent",
    "description": "Shirdi to Manmad Mini Bus on Rent is suitable for larger groups requiring shared private transportation. It can be arranged for pilgrimage groups, family gatherings, organized tours, and travel between Shirdi and Manmad."
  },
  {
    "name": "Shirdi to Manmad One Way Cab",
    "description": "Shirdi to Manmad One Way Cab provides direct transportation for passengers who need a convenient drop at Manmad. The service is suitable for railway station transfers, onward train journeys, business travel, and travelers who do not require a return cab."
  },
  {
    "name": "Shirdi to Manmad Station Taxi Fare",
    "description": "Shirdi to Manmad Station Taxi Fare depends on the vehicle category and pickup or drop requirements. Private cabs can be arranged for passengers traveling from Shirdi to Manmad Railway Station for onward train connections."
  },
  {
    "name": "Shirdi Airport to Manmad Cab Service",
    "description": "Shirdi Airport to Manmad Cab Service provides convenient private transportation for passengers traveling from the airport toward Manmad. Suitable vehicles can be arranged according to passenger count, luggage, pickup timing, and railway station requirements."
  },
  {
    "name": "Manmad to Shirdi Airport Cab Service",
    "description": "Manmad to Shirdi Airport Cab Service offers private transportation for travelers heading from Manmad toward Shirdi Airport. The service is suitable for families, business travelers, devotees, and passengers planning airport transfers with scheduled pickups."
  },
  {
    "name": "Shirdi to Manmad Cab",
    "description": "Shirdi to Manmad Cab provides comfortable point-to-point transportation between the two destinations. Travelers can select a suitable vehicle for railway station transfers, business travel, family journeys, and pilgrimage-related transportation."
  },
  {
    "name": "Shirdi to Manmad Cab Service",
    "description": "Shirdi to Manmad Cab Service offers private transportation for passengers traveling between Shirdi and Manmad. Sedan, Ertiga, SUV, and Innova options can be arranged according to group size, luggage requirements, and preferred travel comfort."
  },
  {
    "name": "Shirdi to Manmad Taxi Service",
    "description": "Shirdi to Manmad Taxi Service provides convenient intercity travel for devotees, families, and travelers. Private cabs can be arranged for direct transfers, railway station drops, local travel, and return journeys."
  },
  {
    "name": "Shirdi to Manmad Cab Booking",
    "description": "Shirdi to Manmad Cab Booking helps passengers reserve their transportation before the journey. Advance booking can be arranged according to pickup time, destination, vehicle category, passenger count, and travel requirements."
  },
  {
    "name": "Cab from Shirdi to Manmad",
    "description": "Cab from Shirdi to Manmad provides a direct travel option for passengers looking for comfortable private transportation. The service is suitable for railway station transfers, business trips, family journeys, and onward travel from Manmad."
  },
  {
    "name": "Taxi from Shirdi to Manmad",
    "description": "Taxi from Shirdi to Manmad offers convenient transportation for travelers requiring a private vehicle between the two destinations. Customers can select an appropriate car based on the number of passengers and luggage."
  },
  {
    "name": "Shirdi Manmad Cab Service",
    "description": "Shirdi Manmad Cab Service provides private transportation for passengers traveling between Shirdi and Manmad throughout the day. The service can accommodate devotees, families, railway passengers, corporate travelers, and small groups."
  },
  {
    "name": "Shirdi to Manmad Car Rental",
    "description": "Shirdi to Manmad Car Rental provides private vehicle options for travelers who prefer comfortable transportation between the two destinations. Cars can be arranged for one-way transfers, round trips, railway station travel, and customized journeys."
  },
  {
    "name": "Shirdi to Manmad Junction Cab",
    "description": "Shirdi to Manmad Junction Cab provides convenient transportation for passengers traveling to Manmad Junction for onward railway connections. Pickup and drop arrangements can be planned according to train schedules and passenger requirements."
  },
  {
    "name": "Shirdi to Manmad One-Way Cab",
    "description": "Shirdi to Manmad One-Way Cab is suitable for travelers requiring a direct drop from Shirdi to Manmad without booking a return vehicle. It can be useful for railway passengers, business travelers, and devotees continuing their journey from Manmad."
  },
  {
    "name": "One-Way Taxi Shirdi to Manmad",
    "description": "One-Way Taxi Shirdi to Manmad provides direct private transportation for passengers who need a single-side journey. The service can be arranged for Manmad Railway Station, Manmad Junction, hotels, and other requested drop locations."
  },
  {
    "name": "Shirdi to Manmad Drop Taxi",
    "description": "Shirdi to Manmad Drop Taxi offers a convenient point-to-point transfer for travelers heading toward Manmad. The service is suitable for passengers catching trains, visiting the city, or continuing onward to another destination."
  },
  {
    "name": "Shirdi to Manmad One-Side Cab",
    "description": "Shirdi to Manmad One-Side Cab provides a practical option for travelers who only require transportation from Shirdi to Manmad. Suitable vehicles can be selected according to passenger count, luggage, and comfort requirements."
  },
  {
    "name": "Shirdi to Manmad Round-Trip Cab",
    "description": "Shirdi to Manmad Round-Trip Cab is suitable for travelers planning a return journey between the two destinations. Families, devotees, and business travelers can arrange a private vehicle for scheduled onward and return transportation."
  },
  {
    "name": "Round-Trip Taxi Shirdi to Manmad",
    "description": "Round-Trip Taxi Shirdi to Manmad provides convenient return transportation for passengers who need to travel between Shirdi and Manmad and come back. Vehicle options can be selected according to group size and travel schedule."
  },
  {
    "name": "Shirdi Manmad Same-Day Return Cab",
    "description": "Shirdi Manmad Same-Day Return Cab allows travelers to complete their journey to Manmad and return to Shirdi on the same day. The option is useful for railway station travel, personal work, business visits, and planned short-distance trips."
  },
  {
    "name": "Manmad to Shirdi Cab",
    "description": "Manmad to Shirdi Cab provides private transportation for passengers traveling from Manmad toward Shirdi Sai Baba Temple. It is suitable for railway passengers, families, devotees, and travelers arriving in Manmad."
  },
  {
    "name": "Manmad to Shirdi Taxi",
    "description": "Manmad to Shirdi Taxi offers comfortable private travel from Manmad to Shirdi. Travelers can arrange suitable vehicles for direct temple visits, family journeys, railway station pickups, and onward pilgrimage plans."
  },
  {
    "name": "Manmad Railway Station to Shirdi Cab",
    "description": "Manmad Railway Station to Shirdi Cab provides convenient pickup transportation for passengers arriving by train. Private cabs can be arranged from the railway station to Shirdi hotels, residences, and Sai Baba Temple areas."
  },
  {
    "name": "Manmad Junction to Shirdi Taxi",
    "description": "Manmad Junction to Shirdi Taxi helps railway passengers continue their journey comfortably from Manmad Junction to Shirdi. Suitable vehicles can be arranged for individuals, families, senior citizens, and pilgrimage groups."
  },
  {
    "name": "Manmad to Shirdi One-Way Cab",
    "description": "Manmad to Shirdi One-Way Cab provides direct transportation for passengers traveling from Manmad toward Shirdi without requiring a return booking. It is suitable for train arrivals, devotees, families, and travelers with fixed onward plans."
  },
  {
    "name": "Manmad Station to Sai Baba Temple Taxi",
    "description": "Manmad Station to Sai Baba Temple Taxi provides private transportation for devotees arriving at Manmad Railway Station and traveling toward Shirdi Sai Baba Temple. Comfortable cab options can be selected according to passenger and luggage requirements."
  },
  {
    "name": "Return Cab Manmad to Shirdi",
    "description": "Return Cab Manmad to Shirdi provides convenient transportation for travelers requiring a return journey after completing their visit to Manmad. The service can be arranged for families, devotees, business travelers, and railway passengers."
  },
  {
    "name": "Shirdi Airport to Manmad Cab",
    "description": "Shirdi Airport to Manmad Cab provides private transportation for passengers traveling from Shirdi Airport toward Manmad. Vehicles can be selected according to luggage, passenger count, airport timing, and preferred comfort level."
  },
  {
    "name": "Shirdi Airport to Manmad Taxi",
    "description": "Shirdi Airport to Manmad Taxi offers convenient airport-to-city transportation for passengers heading toward Manmad. The service can accommodate individual travelers, families, business passengers, and groups with different vehicle requirements."
  },
  {
    "name": "Shirdi Airport to Manmad Railway Station Cab",
    "description": "Shirdi Airport to Manmad Railway Station Cab provides a practical connection between the airport and Manmad Railway Station. Travelers can arrange private transportation according to their flight arrival, train schedule, luggage, and passenger count."
  },
  {
    "name": "Shirdi Airport to Manmad Junction Taxi",
    "description": "Shirdi Airport to Manmad Junction Taxi offers scheduled private transportation for passengers traveling from Shirdi Airport to Manmad Junction. Suitable cars can be arranged for onward railway travel and intercity connections."
  },
  {
    "name": "Cab from Shirdi Airport to Manmad",
    "description": "Cab from Shirdi Airport to Manmad provides direct airport transportation for travelers heading toward Manmad. The service is suitable for airport transfers, railway connections, family travel, business trips, and onward journeys."
  },
  {
    "name": "Shirdi Airport Pickup Manmad Drop",
    "description": "Shirdi Airport Pickup Manmad Drop provides convenient point-to-point transportation from Shirdi Airport to Manmad. Passengers can arrange suitable AC vehicles according to flight timing, luggage requirements, group size, and preferred destination."
  }
],
"tableData": [
  ["Shirdi to Manmad Taxi Fare", "Shirdi to Manmad Taxi"],
  ["Taxi Charges from Manmad to Shirdi", "Manmad to Shirdi Taxi Fare"],
  ["Manmad to Shirdi Cab Fare", "Manmad to Shirdi Cab Booking"],
  ["Manmad to Shirdi Taxi Price", "Cab from Manmad to Shirdi"],
  ["Shirdi to Manmad Innova Crysta Cab", "Shirdi to Manmad Innova Cab"],
  ["Hire Innova Crysta in Shirdi", "Shirdi to Manmad 17 Seater Tempo Traveller on Rent"],
  ["Shirdi to Manmad 7 Seater on Rent", "Shirdi to Manmad Ertiga on Rent"],
  ["Shirdi to Manmad Mini Bus on Rent", "Shirdi to Manmad One Way Cab"],
  ["Shirdi to Manmad Station Taxi Fare", "Shirdi Airport to Manmad Cab Service"],
  ["Manmad to Shirdi Airport Cab Service", "Shirdi to Manmad Cab"],
  ["Shirdi to Manmad Cab Service", "Shirdi to Manmad Taxi Service"],
  ["Shirdi to Manmad Cab Booking", "Cab from Shirdi to Manmad"],
  ["Taxi from Shirdi to Manmad", "Shirdi Manmad Cab Service"],
  ["Shirdi to Manmad Car Rental", "Shirdi to Manmad Junction Cab"],
  ["Shirdi to Manmad One-Way Cab", "One-Way Taxi Shirdi to Manmad"],
  ["Shirdi to Manmad Drop Taxi", "Shirdi to Manmad One-Side Cab"],
  ["Shirdi to Manmad Round-Trip Cab", "Round-Trip Taxi Shirdi to Manmad"],
  ["Shirdi Manmad Same-Day Return Cab", "Manmad to Shirdi Cab"],
  ["Manmad to Shirdi Taxi", "Manmad Railway Station to Shirdi Cab"],
  ["Manmad Junction to Shirdi Taxi", "Manmad to Shirdi One-Way Cab"],
  ["Manmad Station to Sai Baba Temple Taxi", "Return Cab Manmad to Shirdi"],
  ["Shirdi Airport to Manmad Cab", "Shirdi Airport to Manmad Taxi"],
  ["Shirdi Airport to Manmad Railway Station Cab", "Shirdi Airport to Manmad Junction Taxi"],
  ["Cab from Shirdi Airport to Manmad", "Shirdi Airport Pickup Manmad Drop"]
],


        whychoose: [
            { 
                WhyChooseheading: "Convenient Shirdi to Manmad Cab Service", 
                WhyChoosedescription: "Sai Shirdi Cabs offers a practical travel option for passengers heading from Shirdi to Manmad for railway connections, business work, family visits, or onward travel. A private cab provides a direct journey without the need to coordinate multiple local transport options." 
            }, 
            { 
                WhyChooseheading: "Easy Pickup from Shirdi", 
                WhyChoosedescription: "Arrange pickup from your hotel, residence, temple area, railway station surroundings, or another preferred location in Shirdi. The direct pickup facility helps passengers begin their journey according to their planned departure time." 
            }, 
            { 
                WhyChooseheading: "Useful for Manmad Railway Station Transfers", 
                WhyChoosedescription: "Passengers using Manmad as a railway connection can arrange a cab from Shirdi to reach the station with their luggage. This is particularly convenient for families and travellers who want a dedicated vehicle for their station transfer." 
            }, 
            { 
                WhyChooseheading: "Comfortable Travel for Families", 
                WhyChoosedescription: "Families, senior citizens, and small groups can travel together in a suitable cab selected according to passenger count and luggage requirements. The private setting provides greater convenience than changing between different transport services." 
            }, 
            { 
                WhyChooseheading: "One-Way Cab Booking to Manmad", 
                WhyChoosedescription: "Travellers who are continuing their journey by train or another mode of transport can choose a one-way cab from Shirdi to Manmad. This makes the cab useful as part of a longer travel itinerary." 
            }, 
            { 
                WhyChooseheading: "Round-Trip Transportation Option", 
                WhyChoosedescription: "If you need to return to Shirdi after completing your work or visit in Manmad, a round-trip cab arrangement can be planned. Return timing can be discussed according to your overall schedule." 
            }, 
            { 
                WhyChooseheading: "Convenient Luggage Handling", 
                WhyChoosedescription: "Passengers can keep their personal bags and travel belongings with them during the journey. Vehicle selection can be based on the number of travellers and the amount of luggage being carried." 
            }, 
            { 
                WhyChooseheading: "Book Shirdi to Manmad Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your Shirdi pickup point, Manmad destination, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement with Sai Shirdi Cabs to arrange your cab service." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Shirdi to Manmad?", 
            answer: "Yes, Sai Shirdi Cabs provides cab services from Shirdi to Manmad for railway transfers, business travel, family visits, personal work, and onward journeys." 
        }, 
        { 
            question: "Can I book a cab from Shirdi to Manmad Railway Station?", 
            answer: "Yes, passengers can arrange a direct cab from Shirdi to Manmad Railway Station by sharing their preferred pickup location and required arrival time." 
        }, 
        { 
            question: "Is one-way taxi service available from Shirdi to Manmad?", 
            answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Shirdi to Manmad and plan to continue their journey by train or another mode of transport." 
        }, 
        { 
            question: "Can I book a round-trip cab between Shirdi and Manmad?", 
            answer: "Yes, round-trip transportation can be arranged for passengers who need to travel to Manmad and return to Shirdi according to their schedule." 
        }, 
        { 
            question: "Is the Shirdi to Manmad Cab suitable for railway passengers?", 
            answer: "Yes, a private cab can be useful for railway passengers who need direct transportation to Manmad Railway Station with their family and luggage." 
        }, 
        { 
            question: "Can families travel from Shirdi to Manmad by cab?", 
            answer: "Yes, families can select a suitable vehicle according to their passenger count, luggage quantity, and preferred comfort level for the journey." 
        }, 
        { 
            question: "Can senior citizens use the Shirdi to Manmad taxi service?", 
            answer: "Yes, private cab travel can be a convenient choice for families travelling with senior citizens because everyone can remain together during the journey." 
        }, 
        { 
            question: "Can I carry luggage in the Shirdi to Manmad cab?", 
            answer: "Yes, passengers can carry personal luggage according to the capacity of the selected vehicle. Details about extra or bulky baggage should be provided while booking." 
        }, 
        { 
            question: "Can I schedule an early morning cab from Shirdi to Manmad?", 
            answer: "Yes, passengers can request an early morning departure according to their train or travel schedule. The required pickup time should be shared when making the booking." 
        }, 
        { 
            question: "How can I book Shirdi to Manmad Cab with Sai Shirdi Cabs?", 
            answer: "Share your Shirdi pickup location, Manmad destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Sai Shirdi Cabs for booking assistance." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Rahul Gaikwad", 
            feedback: "We needed to reach Manmad Railway Station from Shirdi with our family and luggage. The private cab was a convenient option and made the station transfer much easier for everyone.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Neha Chavan", 
            feedback: "Our return journey from Shirdi required a direct transfer towards Manmad. The cab was comfortable for our family and helped us manage the trip according to our train schedule.", 
            rating: 5 
        } 
    ];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Manmad Cab",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-manmad-cab.webp",
  "description":
    "Book Shirdi to Manmad Cab with Sai Shirdi Cabs for safe, comfortable, and reliable taxi services. We provide affordable one-way and round-trip cabs between Shirdi and Manmad with convenient pickup and drop facilities. Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs are available for railway station transfers, Shirdi temple visits, family trips, business travel, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-manmad-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Shirdi to Manmad Cab | Taxi Fare & Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Manmad Cab with Sai Shirdi Cabs for affordable one-way and round-trip taxi services. Get comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs with professional drivers for Manmad railway station transfers, Shirdi temple visits, family trips, and outstation travel."
  />

  <meta
    name="keywords"
    content="Shirdi to manmad taxi fare, Shirdi to manmad taxi, Taxi charges from manmad to shirdi, manmad to shirdi taxi fare, manmad to shirdi cab fare, manmad to shirdi cab booking, manmad to shirdi taxi price, cab from manmad to shirdi, Shirdi to Manmad Cab, Shirdi to Manmad Taxi Service, Shirdi to Manmad One Way Cab, Shirdi to Manmad Round Trip Cab, Manmad to Shirdi Taxi Booking, Manmad to Shirdi Cab Service, Manmad Railway Station to Shirdi Taxi, Shirdi Temple to Manmad Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditomanmadcab;